import React, { useEffect, useState } from "react"
import { mixDate } from "services/mixin"

interface Props {
    user: any
}
const Membership: React.FC<Props> = ({user}) => {
    const [membership, setMembership] = useState({})
    useEffect(()=>{
        if(Object.keys(user?.customer_package || {}).length > 0) {
            const item = {
                ...user?.customer_package,
                package: {
                    ...user?.customer_package.package,
                    content: user?.customer_package?.package?.content ? JSON.parse(user?.customer_package?.package?.content) : null
                }
            }
            setMembership(item)
        } else {
            return;
        }
    },[user])
    useEffect(()=>{
        console.log(membership)
    },[membership])
    return(
        <section className="card" id="membership">
            <div className="card-header">
                <div className="title-card">Membership</div>
            </div>
            <div className="card-detail">
                <div className="row">
                    <p className="label">Current Plan</p>
                    { Object.keys(membership || {}).length > 0 ? (
                        <p className="value">{ membership?.package?.content?.val1 || membership?.package?.name}</p>
                    ): (
                        <p className="value">{ 'Not thing'}</p>
                    )
                    }
                    <div className="link">Upgrade</div>
                </div>
                <div className="row">
                    <p className="label">Expiry Date</p>
                    { Object.keys(membership || {}).length > 0 ? (
                        <p className="value">{ mixDate(membership?.date_to, {hour: false}) }</p>
                    ): (
                        <p className="value">{ 'Not thing'}</p>
                    )
                    }
                    <div className="link">Extend</div>
                </div>
            </div>
        </section>
    )
}
export default Membership